
import { Vue, Component, Prop } from "nuxt-property-decorator";

@Component({})
export default class MyAccountIcon extends Vue {
  @Prop({ default: false }) isLoggedIn: boolean;
  @Prop({ default: 33 }) width: number;
  @Prop({ default: 33 }) height: number;
}
